import Vue from 'vue';
import WhatsNew from '@/components/pages/WhatsNewPage/WhatsNew.vue'
import WhatsNewHard from '@/components/pages/WhatsNewPage/WhatsNewHardCoded.vue'
import BlogPost from '@/components/pages/WhatsNewPage/BlogPost.vue'

Vue.component('whatsNew', WhatsNew);
Vue.component('whatsNewHard', WhatsNewHard);
Vue.component('blog-post', BlogPost);
